import moment from 'moment';

import { CommitteeDistrictLeadership } from '@domui-domain/districts';

import { DistrictOfficer } from '@typings/operations';

export const areSomeAssigmentAfter = (
  officers: DistrictOfficer[],
  role: Pick<CommitteeDistrictLeadership, 'roleId' | 'endDate'>
) =>
  officers.some(
    officer =>
      officer.roleId === role.roleId &&
      moment(officer.startDate).isAfter(role.endDate, 'd')
  );
